/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsInstagram: {
  name: 'instagram';
  data: string;
} = {
  name: 'instagram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm16 0H5v14h14V5Zm-1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-8 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" fill="currentColor"/></svg>`,
};
